





























import {Component, Vue, Prop, Model} from 'vue-property-decorator';
import {NodeData} from '@/system/nodes/interfaces';

@Component({})
export default class SelectionPM extends Vue {
  // Элементы для выбора
  @Prop({required: true, type: Array})
  items!: [];

  @Prop({required: false, default: null})
  node!: NodeData | null;

  @Prop({required: false, default: false})
  hideChildModules!: boolean;

  // Строка с выбранным пунктами фильтра
  @Prop({required: false, default: ''})
  filterStr!: string;

  // Строка с выбранным пунктами фильтра
  @Prop({required: false, default: false})
  filterStatus!: boolean;

  // Ключевое поле у элементов
  @Prop({required: false, default: 'id'})
  keyFieldName!: string;

  // Получить ключ элемента
  getKey(item: any) {
    return item[this.keyFieldName];
  }

  // Модель для ключей элементов
  @Model('change') selectedItemKey!: any;

  get changeSelectedItem() {
    return this.selectedItemKey;
  }

  set changeSelectedItem(newselectedItemKey: any) {
    this.$emit('change', newselectedItemKey);
  }

  getName(item: any) {
    if (this.node && item.nodeId != this.node.id) {
      if (!this.hideChildModules) return `${item.name} (${item.nodeDescription})`;
      else return null;
    }
    return `${item.name}`;
  }

  //Модель для v-alert фильтра
  get filterInfo() {
    return this.filterStatus;
  }
  set filterInfo(value: boolean) {
    if (!value) this.$emit('clearFilter');
  }
}
